/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type ElectRoleFillerSelect_proposal$ref = any;
type PolicySelect_proposal$ref = any;
type RoleSelect_proposal$ref = any;
type SupportedRoleSelect_proposal$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PartSelector_proposal$ref: FragmentReference;
declare export opaque type PartSelector_proposal$fragmentType: PartSelector_proposal$ref;
export type PartSelector_proposal = {|
  +id: string,
  +tension: ?{|
    +body: string
  |},
  +availableSupportedRoles: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string
      |}
    |}>
  |},
  +$fragmentRefs: RoleSelect_proposal$ref & PolicySelect_proposal$ref & SupportedRoleSelect_proposal$ref & ElectRoleFillerSelect_proposal$ref,
  +$refType: PartSelector_proposal$ref,
|};
export type PartSelector_proposal$data = PartSelector_proposal;
export type PartSelector_proposal$key = {
  +$data?: PartSelector_proposal$data,
  +$fragmentRefs: PartSelector_proposal$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PartSelector_proposal",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Tension",
      "kind": "LinkedField",
      "name": "tension",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "body",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AvailableSupportedRolesConnection",
      "kind": "LinkedField",
      "name": "availableSupportedRoles",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AvailableSupportedRolesEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Role",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RoleSelect_proposal"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PolicySelect_proposal"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SupportedRoleSelect_proposal"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ElectRoleFillerSelect_proposal"
    }
  ],
  "type": "Proposal",
  "abstractKey": null
};
})();
// prettier-ignore
(node/*: any*/).hash = 'e1ed44c4cc5c521c822b0196e1007766';

module.exports = node;
